import { SET_MESSAGES, RESET_MESSAGES } from './mutation-types';

export default {
  [SET_MESSAGES](state, messages) {
    state.messages = messages;
  },
  [RESET_MESSAGES](state) {
    state.messages = [];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/general/mutations.js